// Generated by ReScript, PLEASE EDIT WITH CARE

import * as PartnerContentHelper from "./PartnerContentHelper.bs.js";

function getContent(vehicle_category, geo_region) {
  if (vehicle_category !== 0) {
    return {
            title_text: "ಕಂಪ್ಲೀಷನ್ ಸ್ಕೊರ್ ",
            learn_more_text: "ಇನ್ನಷ್ಟು ತಿಳಿಯಿರಿ",
            info_btn_details: {
              video_url: undefined,
              question: "ಕಂಪ್ಲೀಷನ್ ಸ್ಕೊರ್ ಅಂದರೆ ಏನು?",
              answer: "ನಿಮಗೆ ನೀಡಲಾದ  ಕೊನೆಯ 50 ಆರ್ಡರ್‌ಗಳಲ್ಲಿ ಪೂರ್ಣಗೊಂಡ ಒಟ್ಟು ಆರ್ಡರ್‌ಗಳನ್ನು ಕಂಪ್ಲೀಷನ್ ಸ್ಕೊರೆಂದು  ಲೆಕ್ಕಹಾಕಲಾಗುತ್ತದೆ. \n\n                  ಉದಾ: ಪೋರ್ಟರ್ 50 ಆರ್ಡರ್‌ಗಳನ್ನು ನೀಡಿದ್ದಾರೆ  ಮತ್ತು ನೀವು 40 ಅನ್ನು ಪೂರ್ಣಗೊಳಿಸಿದರೆ, ಕಂಪ್ಲೀಷನ್ ಸ್ಕೊರ್ 40 ಆಗಿದೆ."
            },
            learn_more_btn_details: [
              {
                video_url: PartnerContentHelper.getV1InfoVidTrucks(geo_region),
                question: "ಕಂಪ್ಲೀಷನ್ ಸ್ಕೊರ್ ಅಂದರೆ ಏನು ಮತ್ತು ಅದು ಏಕೆ ಮುಖ್ಯ?",
                answer: ""
              },
              {
                video_url: undefined,
                question: "ನನ್ನ ಕಂಪ್ಲೀಷನ್ ಸ್ಕೊರನ್ನು  ಹೇಗೆ ಸುಧಾರಿಸಬಹುದು?",
                answer: "ಹೆಚ್ಚಿನ ಕಂಪ್ಲೀಷನ್ ಸ್ಕೊರನ್ನು ನಿರ್ವಹಿಸಲು ಎಲ್ಲಾ ಆರ್ಡರ್ ಗಳನ್ನು  ಸ್ವೀಕರಿಸಿ ಮತ್ತು ಪೂರ್ಣಗೊಳಿಸಿ"
              },
              {
                video_url: undefined,
                question: "ಉತ್ತಮ ಕಂಪ್ಲೀಷನ್ ಸ್ಕೊರ್ ಯಾವುದು?",
                answer: "ಅತಿ ಹೆಚ್ಚು ಗಳಿಸುವ ಪೋರ್ಟರ್ ಪಾಲುದಾರರು 90% ಅಥವಾ ಅದಕ್ಕಿಂತ ಹೆಚ್ಚಿನ ಸ್ಕೋರ್ ಅನ್ನು ಹೊಂದಿರುತ್ತಾರೆ."
              },
              {
                video_url: undefined,
                question: "ನನ್ನ ಕಂಪ್ಲೀಷನ್ ಸ್ಕೊರನ್ನು ನೋಡಲು ನನಗೆ ಏಕೆ ಸಾಧ್ಯವಾಗುತ್ತಿಲ್ಲ?",
                answer: "ಕನಿಷ್ಠ 50 ಆರ್ಡರ್‌ಗಳನ್ನು ಪಡೆದ ಪಾಲುದಾರರಿಗೆ ಮಾತ್ರ ಸ್ಕೋರ್ ಅನ್ನು ಲೆಕ್ಕಹಾಕಲಾಗುತ್ತದೆ."
              }
            ],
            locked_score_msg: "ಸ್ಕೋರ್ ಅನ್‌ಲಾಕ್ ಮಾಡಲು ಹೆಚ್ಚಿನ ಟ್ರಿಪ್‌ಗಳನ್ನು ಪೂರ್ಣಗೊಳಿಸಿ",
            message_text: "ಹೆಚ್ಚಿನ ಕಂಪ್ಲೀಷನ್ ಸ್ಕೊರ್  ಹೊಂದಿರುವ ಪಾಲುದಾರರು ಹೆಚ್ಚಿನ ಆರ್ಡರ್‌ಗಳನ್ನು ಪಡೆಯುವ ಅವಕಾಶಗಳನ್ನು ಹೊಂದಿರುತ್ತಾರೆ."
          };
  } else {
    return {
            title_text: "ಕಂಪ್ಲೀಷನ್ ಸ್ಕೊರ್ ",
            learn_more_text: "ಇನ್ನಷ್ಟು ತಿಳಿಯಿರಿ",
            info_btn_details: {
              video_url: undefined,
              question: "ಕಂಪ್ಲೀಷನ್ ಸ್ಕೊರ್ ಅಂದರೆ ಏನು?",
              answer: "ನಿಮಗೆ ನಿಯೋಜಿಸಲಾದ ಕೊನೆಯ 50 ಆರ್ಡರ್‌ಗಳಲ್ಲಿ ಪೂರ್ಣಗೊಂಡ ಒಟ್ಟು ಆರ್ಡರ್‌ಗಳನ್ನು ಪೂರ್ಣಗೊಳಿಸುವಿಕೆಯ ಸ್ಕೋರ್ ಅನ್ನು ಲೆಕ್ಕಹಾಕಲಾಗುತ್ತದೆ. ಆರ್ಡರ್‌ಗಳನ್ನು ನಿಮಗೆ ಪಿಂಗ್ ಮಾಡಲಾಗಿ  ಆದರೆ ಆರ್ಡರ್‌  ಇನ್ನೊಬ್ಬ ಪಾಲುದಾರರಿಂದ ಸ್ವೀಕರಿಸಲಾಗಿ ನಿಮ್ಮ ಸ್ಕೋರ್‌ನಲ್ಲಿ ಪರಿಗಣಿಸಲಾಗುವುದಿಲ್ಲ. \n\n                  ಉದಾ : ಪೋರ್ಟರ್ 50 ಆರ್ಡರ್‌ಗಳನ್ನು  ನಿಯೋಜಿಸಿದರೆ ಮತ್ತು ನೀವು 40  ಆರ್ಡರ್‌ಗಳನ್ನು ಪೂರ್ಣಗೊಳಿಸಿದರೆ, ನೀಮಗೆ ಪೂರ್ಣಗೊಳಿಸುವಿಕೆ ಸ್ಕೋರ್ 80%"
            },
            learn_more_btn_details: [
              {
                video_url: PartnerContentHelper.getV1InfoVid2w(geo_region),
                question: "ಕಂಪ್ಲೀಷನ್ ಸ್ಕೊರ್ ಅಂದರೆ ಏನು ಮತ್ತು ಅದು ಏಕೆ ಮುಖ್ಯ?",
                answer: ""
              },
              {
                video_url: undefined,
                question: "ನನ್ನ ಕಂಪ್ಲೀಷನ್ ಸ್ಕೊರನ್ನು  ಹೇಗೆ ಸುಧಾರಿಸಬಹುದು?",
                answer: "ಹೆಚ್ಚಿನ ಕಂಪ್ಲೀಷನ್ ಸ್ಕೊರನ್ನು ನಿರ್ವಹಿಸಲು ಎಲ್ಲಾ ಆರ್ಡರ್ ಗಳನ್ನು  ಸ್ವೀಕರಿಸಿ ಮತ್ತು ಪೂರ್ಣಗೊಳಿಸಿ"
              },
              {
                video_url: undefined,
                question: "ಉತ್ತಮ ಕಂಪ್ಲೀಷನ್ ಸ್ಕೊರ್ ಯಾವುದು?",
                answer: "ಅತಿ ಹೆಚ್ಚು ಗಳಿಸುವ ಪೋರ್ಟರ್ ಪಾಲುದಾರರು 90% ಅಥವಾ ಅದಕ್ಕಿಂತ ಹೆಚ್ಚಿನ ಸ್ಕೋರ್ ಅನ್ನು ಹೊಂದಿರುತ್ತಾರೆ."
              },
              {
                video_url: undefined,
                question: "ನನ್ನ ಕಂಪ್ಲೀಷನ್ ಸ್ಕೊರನ್ನು ನೋಡಲು ನನಗೆ ಏಕೆ ಸಾಧ್ಯವಾಗುತ್ತಿಲ್ಲ?",
                answer: "ಕನಿಷ್ಠ 50 ಆರ್ಡರ್‌ಗಳನ್ನು ಪಡೆದ ಪಾಲುದಾರರಿಗೆ ಮಾತ್ರ ಸ್ಕೋರ್ ಅನ್ನು ಲೆಕ್ಕಹಾಕಲಾಗುತ್ತದೆ."
              }
            ],
            locked_score_msg: "ಸ್ಕೋರ್ ಅನ್‌ಲಾಕ್ ಮಾಡಲು ಹೆಚ್ಚಿನ ಟ್ರಿಪ್‌ಗಳನ್ನು ಪೂರ್ಣಗೊಳಿಸಿ",
            message_text: "ಹೆಚ್ಚಿನ ಕಂಪ್ಲೀಷನ್ ಸ್ಕೊರ್  ಹೊಂದಿರುವ ಪಾಲುದಾರರು ಹೆಚ್ಚಿನ ಆರ್ಡರ್‌ಗಳನ್ನು ಪಡೆಯುವ ಅವಕಾಶಗಳನ್ನು ಹೊಂದಿರುತ್ತಾರೆ."
          };
  }
}

export {
  getContent ,
  
}
/* No side effect */
